import type { Severity } from "@reviewer73/shared";

const CONFIG: Record<Severity, { label: string; color: string }> = {
  critical: { label: "kritisch", color: "var(--sev-critical)" },
  high: { label: "hoch", color: "var(--sev-high)" },
  medium: { label: "mittel", color: "var(--sev-medium)" },
  low: { label: "niedrig", color: "var(--sev-low)" },
};

/** Severity as a softly tinted pill; the tint derives from the ink color. */
export function SeverityBadge({ severity }: { severity: Severity }) {
  const { label, color } = CONFIG[severity];
  return (
    <span
      className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold"
      style={{
        color,
        background: `color-mix(in srgb, ${color} 10%, var(--background))`,
      }}
    >
      {label}
    </span>
  );
}
